var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.672 7.51a5.7 5.7 0 0 0-1.67-.25 4.99 4.99 0 1 0 4.16 2.22M14.383 7.65l-1.66-1.91M14.381 7.65l-1.94 1.42"
})));
export { SvgReplay as ReactComponent };
export default __webpack_public_path__ + "51e0ea128feaf732ca12730a230cded6.svg";